import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { MatDatepickerInput } from '@angular/material/datepicker';
import { NgControl } from '@angular/forms';
import moment from 'moment';
import { DATE_FORMAT } from '../shared/constants/date.constants';

/**
 * Date Directive
 * 1. 限制date input只能輸入數字和斜線(/)
 * 2. 預設限制日期輸入的最大值為當前日期(不可選擇未來日期，直接輸入未來日期會自動轉為當前日期)  [future]="true" 可允許未來日期
 */
@Directive({
  selector: '[appDateInput]',
  standalone: true,
})
export class DateInputDirective implements OnInit {
  @Input('maxDate') maxDate: Date = new Date();
  @Input('future') future: boolean = false; // 是否允許未來日期

  constructor(
    private dateInput: MatDatepickerInput<Date>,
    private ngControl: NgControl
  ) {}

  ngOnInit() {
    if (!this.future) {
      this.dateInput.max = this.maxDate;
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    // 過濾後的值
    const filtered = input.value.replace(/[^0-9/]/g, '');
    if (filtered !== input.value) {
      input.value = filtered;
      // 觸發 FormControl 更新
      this.updateFormControl(filtered);
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: InputEvent) {
    if (this.future) return; // 如果允許未來日期，則不進行檢查
    const input = event.target as HTMLInputElement;
    if (!input) return;
    const value = input.value;
    if (!value) return;

    // 格式為 yyyy/MM/dd
    const date = new Date(value.replace(/-/g, '/'));
    if (isNaN(date.getTime())) return;

    if (date > this.maxDate) {
      const today = this.maxDate;
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      const formattedDate = `${yyyy}/${mm}/${dd}`;
      input.value = formattedDate;

      this.updateFormControl(formattedDate);
    }
  }

  // 更新FormControl的值
  private updateFormControl(value: string) {
    if (this.ngControl && this.ngControl.control) {
      const momentValue = moment(value, DATE_FORMAT);
      if (momentValue.isValid()) {
        this.ngControl.control.setValue(momentValue);
        this.ngControl.control.markAsTouched();
      }
    }
  }
}
